import BlogFeatureArticleGalleryUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/BlogFeatureArticleGallery/BlogFeatureArticleGallery'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

type Props = UIProps
const BlogFeatureArticleGallery = (props: Props) => {
  const { title, items } = props

  const analytics = useAnalytics()

  const blogArticleGalleryUrlAnalytics = (linkText: string) => {
    analytics.blogArticleGalleryAnalytics(linkText)
  }
  useLoaded(props)
  return (
    <BlogFeatureArticleGalleryUI
      title={title}
      items={items}
      blogArticleGalleryUrlAnalytics={blogArticleGalleryUrlAnalytics}
    />
  )
}

export default BlogFeatureArticleGallery
